import Icon from '@uikit/components/Icon/Icon';
import styles from './CourseDetailCardButton.module.scss';
import type { CourseDetailCardButtonProps } from './interfaces';

const CourseDetailCardButton = ({
  children,
  ...props
}: CourseDetailCardButtonProps) => {
  return (
    <button type="button" className={styles.button} {...props}>
      <Icon variant="action/chevron-down" size="iconSize24" />
      <span>{children}</span>
    </button>
  );
};

export default CourseDetailCardButton;
